import { VALUE_TYPE } from "c8-platform";
import { LocalizationRes } from "@centricsoftware/design-system";
import types from "csi/types";
import { ILocaleProvider } from "designSystem/locale";
import AttributeDefinitionStore from "./AttributeDefinitionStore";

export const TYPES = [
	VALUE_TYPE.BOOLEAN,
	VALUE_TYPE.BOOLEAN_LIST,
	VALUE_TYPE.BOOLEAN_MAP,
	VALUE_TYPE.BOOLEAN_VECT,
	VALUE_TYPE.DOUBLE,
	VALUE_TYPE.DOUBLE_LIST,
	VALUE_TYPE.DOUBLE_MAP,
	VALUE_TYPE.DOUBLE_VECT,
	VALUE_TYPE.ENUM,
	VALUE_TYPE.ENUM_MAP,
	VALUE_TYPE.ENUM_LIST,
	VALUE_TYPE.ENUM_VECT,
	VALUE_TYPE.INTEGER,
	VALUE_TYPE.INTEGER_MAP,
	VALUE_TYPE.INTEGER_LIST,
	VALUE_TYPE.INTEGER_VECT,
	VALUE_TYPE.INTEGER_SET,
	VALUE_TYPE.STRING,
	VALUE_TYPE.STRING_MAP,
	VALUE_TYPE.STRING_LIST,
	VALUE_TYPE.STRING_VECT,
	VALUE_TYPE.STRING_SET,
	VALUE_TYPE.TIME,
	VALUE_TYPE.TIME_MAP,
	VALUE_TYPE.TIME_LIST,
	VALUE_TYPE.TIME_VECT,
	VALUE_TYPE.URL,
	VALUE_TYPE.REF,
	VALUE_TYPE.REF_MAP,
	VALUE_TYPE.REF_LIST,
	VALUE_TYPE.REF_VECT,
	VALUE_TYPE.REF_SET,
];

export interface AttributeDefinitionDialogProps {
	loc: ILocaleProvider;
	onClickSaveNew: VoidFunction; 
	onClose: VoidFunction; 
	onSave: VoidFunction; 
	store: AttributeDefinitionStore; 
	title?: string;
	titleRes?: LocalizationRes;
}

export const COLUMN_SIZE_LOCALIZED = {
	[types.XSMALL]: "AttributeDefinitionColumnSizeExtraSmall",
	[types.SMALL]: "AttributeDefinitionColumnSizeSmall",
	[types.MEDIUM]: "AttributeDefinitionColumnSizeMedium",
	[types.LARGE]: "AttributeDefinitionColumnSizeLarge",
	[types.XLARGE]: "AttributeDefinitionColumnSizeExtraLarge",
};
